<script setup>
import {ref, watch, computed, getCurrentInstance} from 'vue'

const props = defineProps({
    customerId: {
        type: Number,
        required: true
    },
    orderId: {
        type: Number,
        required: true
    }
})

const {proxy} = getCurrentInstance()
const store = proxy.$store

// --- State ---
const customer = ref({})
const order = ref({})

// --- Fetching Data ---
watch(() => props.customerId, async (newId) => {
    customer.value = newId
        ? await store.dispatch('itemData/get', {tableName: 'm_registrants_registrants', id: newId})
        : {}
}, {immediate: true})

watch(() => props.orderId, async (newId) => {
    order.value = newId
        ? await store.dispatch('itemData/get', {tableName: 'm_basket_orders', id: newId})
        : {}
}, {immediate: true})

// --- Computed Active Profile ---
const activeProfile = computed(() => {
    const isOrderProfileValid = Boolean(order.value?.firstName)
    const source = isOrderProfileValid ? order.value : customer.value

    return {
        firstName: source.firstName || '',
        lastName: source.lastName || '',
        email: source.email || '',
        mobile: source.mobile || '',
        telephone: source.telephone || '',
        billingAddress1: source.billingAddress1 || '',
        billingAddress2: source.billingAddress2 || '',
        billingTown: source.billingTown || '',
        billingCounty: source.billingCounty || '',
        billingPostcode: source.billingPostcode || '',
        billingCountry: source.billingCountry || '',
        address1: source.address1 || '',
        address2: source.address2 || '',
        townCity: source.townCity || '',
        county: source.county || '',
        postcode: source.postcode || '',
        country: source.country || ''
    }
})
</script>

<template>
    <div v-if="activeProfile.firstName" class="card-group">
        <div class="card">
            <div class="card-header">{{ activeProfile.firstName }} {{ activeProfile.lastName }}</div>
            <div class="card-body">
                <p class="card-text">
                    <a :href="'mailto:' + activeProfile.email" @click.stop>{{ activeProfile.email }}</a>
                </p>
                <p class="card-text">
                    <a :href="'tel:' + (activeProfile.mobile || activeProfile.telephone)" @click.stop>
                        {{ activeProfile.mobile || activeProfile.telephone }}
                    </a>
                </p>
            </div>
        </div>

        <div class="card">
            <div class="card-header">Billing address</div>
            <div class="card-body">
                <template v-if="activeProfile.billingAddress1">{{ activeProfile.billingAddress1 }}<br></template>
                <template v-if="activeProfile.billingAddress2">{{ activeProfile.billingAddress2 }}<br></template>
                <template v-if="activeProfile.billingTown">{{ activeProfile.billingTown }}<br></template>
                <template v-if="activeProfile.billingCounty">{{ activeProfile.billingCounty }}<br></template>
                <template v-if="activeProfile.billingPostcode">{{ activeProfile.billingPostcode }}<br></template>
                {{ activeProfile.billingCountry }}
            </div>
        </div>

        <div class="card">
            <div class="card-header">Delivery address</div>
            <div class="card-body">
                <template v-if="activeProfile.address1">{{ activeProfile.address1 }}<br></template>
                <template v-if="activeProfile.address2">{{ activeProfile.address2 }}<br></template>
                <template v-if="activeProfile.townCity">{{ activeProfile.townCity }}<br></template>
                <template v-if="activeProfile.county">{{ activeProfile.county }}<br></template>
                <template v-if="activeProfile.postcode">{{ activeProfile.postcode }}<br></template>
                {{ activeProfile.country }}
            </div>
        </div>
    </div>
</template>